import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import * as stApi from '../api/station-tools-api';
import AuthHelper from '../helpers/auth-helper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Page from '../components/Page';
import Logo from '../img/logo.svg';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { FormEvent } from 'react';
import { showNotification } from '../store/notification.actions';

export function LoginPage(): JSX.Element {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        const target = e.target as typeof e.target & {
          email: { value: string };
          password: { value: string };
        };
        const response = await stApi.login(
          target.email.value,
          target.password.value
        );
        AuthHelper.setToken(response.data.authToken);
        navigate('/', { replace: true });
      } catch (err) {
        dispatch(
          showNotification({
            message: t('wrong_email_or_password'),
            severity: 'error',
          })
        );
      }
    },
    [navigate, dispatch, t]
  );

  return (
    <Page>
      <form
        className={classes.container}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <img className={classes.logo} src={Logo} alt="Logo" />
        <TextField
          variant="standard"
          id="email"
          label={t('Email')}
          type="email"
          margin="dense"
          autoComplete="username"
        />
        <TextField
          variant="standard"
          id="password"
          label={t('Password')}
          type="password"
          margin="normal"
          autoComplete="current-password"
        />
        <FormControl variant="standard" margin="normal">
          <Button color="primary" variant="contained" type="submit">
            {t('log_in')}
          </Button>
        </FormControl>
      </form>
    </Page>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
    padding: theme.spacing(),
  },
  logo: {
    width: '150px',
  },
}));
